import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	configGenerator: {
		marginTop: '8rem',
		overflow: 'hidden',
		// border: '2px solid red',
		display: 'flex',
		width: '97vw',
		height: '85vh',
		justifyContent: 'space-around !important',
		backgroundColor: '#E5E7E9',
		borderRadius: '5px',
		alignItems: 'center !important'
	},
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 'fit-content !important',
		height: 'fit-content',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem',
		overflowY: 'scroll'
	},
	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	VideoSectionSelector: {
		position: 'fixed',
		display: 'flex',
		alignItems: 'center',
		margin: '.7rem 1rem',
		top: 0,
		right: '8rem',
		zIndex: 2
	}
}));
